// extracted by css-extract-rspack-plugin
export default {"list":"list-EpMk11","loading":"loading-LeEysP"};